import React, { useCallback } from 'react';
import { SecondaryButton, ButtonGrid } from '@kallidus/common';
import { useMutation, useApolloClient } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LOGOUT_MUTATION from '@Mutations/logout_mutation.graphql';
import { usePreAuthConfig } from '@ApplicationWide/auth/usePreAuthConfig';
import { removeCurrentViewAsUserId } from '@ApplicationWide/fetchConfigHelper';
import Cookies from 'js-cookie';
import './Logout.less';

export const useLogout = () => {
  const preAuthConfig = usePreAuthConfig();
  const history = useHistory();
  const apolloClient = useApolloClient();

  const [logoutUser, { loading: logoutUserLoading }] = useMutation(LOGOUT_MUTATION, {
    onCompleted({ logout }) {
      if (logout.success) {
        localStorage.clear();
        sessionStorage.clear();
        apolloClient.clearStore();
        Cookies.remove('combinedAccess');
        window.location.reload();
      } else {
        history.push('/');
      }
    },
    onError() {
      history.push('/');
    },
  });

  const handleLogout = useCallback(async () => {
    if (preAuthConfig?.idsAuthenticationFeatureFlag) {
      localStorage.clear();
      sessionStorage.clear();
      apolloClient.clearStore();
      removeCurrentViewAsUserId();
      window.location.href = `${window.baseAppConfig.bffPath}/logout`;
    } else {
      await logoutUser();
    }
  }, [preAuthConfig?.idsAuthenticationFeatureFlag, apolloClient, logoutUser]);

  return { logoutUser: handleLogout, logoutUserLoading };
};

export const PreboardingLogout = () => {
  const { t } = useTranslation();
  const { logoutUser } = useLogout();
  return (
    <ButtonGrid className='logout-button'>
      <SecondaryButton onClick={logoutUser}>{t('logout-button.logout')}</SecondaryButton>
    </ButtonGrid>
  );
};
